import React from 'react';
import classname from 'classnames';
import { connect } from 'react-redux';
import { Icons } from '../../configurations/app-configs/app-icons';
import '../../assets/styles/components/paging.scss';
import { Pager } from '../../constants/grid';
import { getPager } from '../../helpers/functions';

class GridFooter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pager: null,
      currentPage: 1,
      pages: []
    }
  }

  componentDidMount() {
    this.getPager();
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.length !== prevProps.data.length) {
      this.getPager();
    }
  }

  getPager() {
    const { data, paginationPageSize } = this.props;
    this.setState({
      pager: getPager(data ? data.length : 0, this.state.currentPage, paginationPageSize),
      pages: getPager(data ? data.length : 0, this.state.currentPage, paginationPageSize).pages
    })
  }

  onPageChanged(page) {
    if (page === this.state.currentPage) return;
    this.props.onPageChanged(page);
    this.setState({
      currentPage: page
    }, () => {
      this.getPager();
    })
  }

  render() {
    const { language, ...props } = this.props;
    const { pager, pages } = this.state;

    return (
      <React.Fragment>
        {pager && <div className="table-footer-container">
          <div className="paging-container">
            <ul className="paging-ul">
              <li className="paging-li">
                <a onClick={() => this.onPageChanged(0)}
                  title={language.firstPage}
                  className={classname("a-click paging-btn", (pager.currentPage === 1 || pager.currentPage === 0) ? "disabled" : "pointer ")}>
                  <Icons.ArrowDoubleLeft />
                </a>
              </li>
              <li >
                <a onClick={() => this.onPageChanged(pager.currentPage - 1)}
                  title={language.previousPage}
                  className={classname("a-click paging-btn", (pager.currentPage === 1 || pager.currentPage === 0) ? "disabled" : "pointer ")}>
                  <Icons.ArrowLeft />
                </a>
              </li>
              <React.Fragment>
                {pages.map(pageItem => {
                  return (
                    <li key={pageItem}>
                      <a onClick={() => this.onPageChanged(pageItem)}
                        className={classname("pointer a-click paging-btn page-number", pageItem === pager.currentPage && "active")}>{pageItem}</a>
                    </li>
                  )
                })}
              </React.Fragment>
              <li>
                <a onClick={() => this.onPageChanged(pager.currentPage + 1)}
                  title={language.nextPage}
                  className={classname("a-click paging-btn", (pager.currentPage === pager.totalPages || pager.currentPage === 0) ? "disabled" : "pointer ")}>
                  <Icons.RightArrow />
                </a>
              </li>
              <li >
                <a onClick={() => this.onPageChanged(pager.totalItems)}
                  title={language.lastPage}
                  className={classname("a-click paging-btn", (pager.currentPage === pager.totalPages || pager.currentPage === 0) ? "disabled" : "pointer ")}>
                  <Icons.ArrowDoubleRight />
                </a>
              </li>
              <li className="page-info">{language.page.format(pager.currentPage)} {language.of.format(pager.totalPages)} ({pager.totalItems} {language.items})</li>
            </ul>
          </div>
        </div>}
      </React.Fragment>
    )
  }
}

GridFooter.defaultProps = {
  exportExcel: false
}

export default connect(
  state => ({
    language: state.app.language
  })
)(GridFooter)